import _ from 'lodash'

function cloneWithoutResponseDataset (obj) {
	let cloned = _.cloneDeep(_.omit(obj, 'response', 'model'))
	if (obj.response) {
		// #43079 #43303 leave dataset out of response object; it isn't used
		// (DatasetTableWidgetConfig gets a cached Dataset model itself)
		// and it can be very expensive to clone, particularly for the
		// larger SMS datasets
		cloned.response = _.cloneDeep(_.omit(obj.response, 'dataset'))
	}

	// #43335 the Dataset model doesn't need to be cloned, and cloning it
	// can be expensive. Just re-use the one that was passed in
	cloned.model = obj.model

	return cloned
}

export default cloneWithoutResponseDataset

cloneWithoutResponseDataset.__filename__ = 'datasets/clone-without-response-dataset.js'
